import { useMemo } from "react";
import { useParticipants } from "@livekit/components-react";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { ProviderPeersList } from "../types";
import { convertParticipantToPeer } from "./helpers";

export const useLivekitPeersList = (): ProviderPeersList => {
  const participants = useParticipants();
  const peers = participants.map(convertParticipantToPeer);

  const peersWithHandRaised = useMemo(
    () => peers.filter(peer => peer.isHandRaised),
    [peers],
  );

  const hosts = useMemo(
    () => peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.HOST),
    [peers],
  );

  const spectators = useMemo(
    () =>
      peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.HLS_SPECTATOR),
    [peers],
  );

  const moderators = useMemo(
    () => peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.MODERATOR),
    [peers],
  );

  return {
    peers,
    peersWithHandRaised,
    hosts,
    spectators,
    moderators,
  };
};
